/**
 * EmailTransferForm - Email transfer form component
 */
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const EmailTransferForm = ({ recipientEmail, setRecipientEmail }) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="recipient-email">Recipient Email</Label>
      <Input
        id="recipient-email"
        type="email"
        placeholder="recipient@example.com"
        value={recipientEmail}
        onChange={(e) => setRecipientEmail(e.target.value)}
        className="h-12 rounded-xl"
        data-testid="recipient-email-input"
      />
      <p className="text-xs text-muted-foreground">
        Must be a registered ParachPay user
      </p>
    </div>
  );
};

export default EmailTransferForm;
